import { Injectable } from '@angular/core';
import { environment } from 'apps/website/src/environments/environment';

/**
 * Servicio encargado de proveer la ip address
 */
@Injectable({
  providedIn: 'root',
})
export class IpServiceService {

  public async getIPAddress(): Promise<void> {
    // Si estamos en desarrollo, usar IP local directamente
    if (!environment.production || this.isLocalhost()) {
      localStorage.setItem('ip', '127.0.0.1');
      return;
    }

    // En producción, intentar obtener la IP real
    const ipServices = [
      'https://api.ipify.org?format=json',
      'https://httpbin.org/ip',
      'https://ipapi.co/json/',
      'https://ipv4.jsonip.com'
    ];

    for (let i = 0; i < ipServices.length; i++) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);

        const response = await fetch(ipServices[i], {
          signal: controller.signal,
          headers: {
            'Accept': 'application/json',
          }
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const info = await response.json();
        const ip = info.ip || info.origin || '0.0.0.0';

        localStorage.setItem('ip', ip);
        return;

      } catch (error) {
        console.warn(`Servicio ${ipServices[i]} falló:`, error);

        // Si es el último servicio y también falla
        if (i === ipServices.length - 1) {
          localStorage.setItem('ip', '0.0.0.0');
        }
      }
    }
  }

  private isLocalhost(): boolean {
    const hostname = window.location.hostname;
    return hostname === 'localhost' ||
           hostname === '127.0.0.1' ||
           hostname === '0.0.0.0' ||
           hostname.startsWith('192.168.') ||
           hostname.startsWith('10.') ||
           hostname.includes('local');
  }
}

// Versión alternativa más simple para desarrollo
export class IpServiceSimple {

  public async getIPAddress(): Promise<void> {
    try {
      // Detectar si estamos en localhost
      if (window.location.hostname === 'localhost' ||
          window.location.hostname === '127.0.0.1') {
        localStorage.setItem('ip', '127.0.0.1');
        return;
      }

      // Solo en producción intentar obtener IP real
      const response = await fetch('https://api.ipify.org?format=json', {
        headers: { 'Accept': 'application/json' }
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('ip', data.ip);
      } else {
        throw new Error('No se pudo obtener IP');
      }

    } catch (error) {
      console.warn('Error obteniendo IP, usando fallback:', error);
      localStorage.setItem('ip', '0.0.0.0');
    }
  }
}
